import { TFunction } from 'i18next';
import {
  getBrowserName,
  isIOS,
  isMac,
  isMobile,
} from '../Common/Utils/platforms';
import env from '../env';
import { Path } from '../Routing';

export type ActivationButtonStatusMsg = {
  button: 'ACTIVATE' | 'DOWNLOAD';
  msg: string;
};

export const isSafari = () => {
  return getBrowserName() === 'ios';
};

export const isChrome = () => {
  return getBrowserName() === 'crios';
};

export const getActivationButtonStatusMsg = (
  t: TFunction<'translation'>
): ActivationButtonStatusMsg | undefined => {
  if (isIOS && !isSafari()) {
    if (isChrome()) {
      return {
        button: 'ACTIVATE',
        msg: t('extension.itvActivation.cashSaver.usingChromeMsg'),
      };
    }
    return {
      button: 'ACTIVATE',
      msg: t('extension.itvActivation.cashSaver.unsupportedBrowserMsg'),
    };
  }

  return {
    button: 'DOWNLOAD',
    msg: t('extension.itvActivation.cashSaver.downloadCompleteMsg'),
  };
};

export const getExtensionInstallMsg = (t: TFunction<'translation'>) => {
  if (isMac) {
    return t('extension.itvActivation.cashSaver.unsupportedMacBrowserMsg');
  }

  return t('extension.itvActivation.cashSaver.unsupportedPCBrowserMsg');
};

export const onActivateButtonClick = () => {
  return '';
};

export const getActivateButtonLink = () => {
  if (isIOS) {
    return Path.PluginActivationV2ActivatePlugin;
  }

  return Path.PluginActivationV2;
};

/**
 * returns undefined if browser is not chrome or safari to disable the button
 */
export const getDesktopExtensionInstallButtonLink = () => {
  if (!isMobile()) {
    if (getBrowserName() === 'chrome') {
      return env.chrome_extension_store_url;
    }

    if (getBrowserName() === 'safari') {
      return env.safari_extension_store_url;
    }

    return undefined;
  }
};

export const getDownloadButtonLink = () => {
  if (isIOS) {
    return env.itv_ios_appstore_link;
  }
  return env.itv_android_appstore_link;
};
